import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-select-more-minus',
    templateUrl: './select-more-minus.component.html'
})
export class SelectMoreMinusComponent implements OnInit {

    @Input() text;
    @Input() limit;
    @Output() change = new EventEmitter();
    counter = 0;

    constructor() {
    }

    ngOnInit() {
    }

    count(order) {
        this.counter += order ? 1 : -1;

        if (this.counter === -1) {
            this.counter = 0;
        }

        if(this.limit && this.counter > this.limit) {
          this.counter = this.limit;
          return;
        }

        this.change.emit(this.counter);
    }

}



// WEBPACK FOOTER //
// ./src/components/select-more-minus/select-more-minus.component.ts